'use strict';

var Backbone = require('backbone'),

  SessionModel = Backbone.Model.extend({

    defaults: function() {
      return {
        loggedIn: null,
        checkingLoggedInState: false,
        userDisplayName: ''
      };
    }

  });

module.exports = SessionModel;



// WEBPACK FOOTER //
// ./assets/js/session/sessionModel.js